import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { defaultServerUrls, environment } from '@paragon/environment-tools';
import { changeTracker, insertions, layoutModels } from '@paragon/layout-models';
import { logInData, organizationMembers } from '@paragon/login-tools';
import { materialLists } from '@paragon/material-lists';
import { enqueuePermanentError, notifications } from '@paragon/notification-tools';
import { SyncClient } from '@paragon/sync-client';
import { spinnerMessages } from '@paragon/task-spinner';
import { theme } from '@paragon/themes';

import { analysisHistory } from './analysisHistorySlice';
import { annotationTemplates } from './annotationTemplatesSlice';
import { application } from './applicationSlice';
import { batches } from './batchesSlice';
import { bundles } from './bundlesSlice';
import { componentDesignSealTimestamps } from './componentDesignSealTimestamps';
import { componentDesignTimestamps } from './componentDesignTimestamps';
import { grid } from './gridSlice';
import { popup } from './popupSlice';
import { productionComponentInstances } from './productionComponentInstancesSlice';
import { productionGroups } from './productionGroupsSlice';
import { projectFilters } from './projectFiltersSlice';
import { projectMetrics } from './projectMetricsSlice';

const rootReducer = combineReducers({
  logInData,
  organizationMembers,
  spinnerMessages,
  environment,
  popup,
  notifications,
  changeTracker,

  analysisHistory,
  annotationTemplates,
  application,
  componentDesignTimestamps,
  componentDesignSealTimestamps,
  grid,
  projectFilters,
  materialLists,
  productionGroups,
  projectMetrics,
  batches,
  bundles,
  productionComponentInstances,

  layoutModels,
  insertions,
  theme,
});

export const syncClient = new SyncClient({
  serverUrl: defaultServerUrls[process.env.APP_ENV!].synchronizationServerUrl,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(syncClient.state.middleware),
});

syncClient.on('error', (event: any) => {
  console.error('sync error', event);
  store.dispatch(enqueuePermanentError('Unable to synchronize.  Please refresh the page.'));
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
